import {ResoknadMedlemskap, ResoknadStatus} from "../../api/resoknadstatus";
import {erAktiv, Prissoknad} from "../../api/prissoknader";
import InnsendtPrissøknad from "./Cards/InnsendtPrissøknadCard";
import AktivResøknadCard from "./Cards/AktivResøknadCard";
import ResøknadslistenMenIngenSøknad from "./Cards/ResøknadslistenMenIngenSøknadCard";
import React, {useMemo} from "react";

interface Props {
    resoknadMedlemskap: ResoknadStatus | undefined;
    prissøknader: Array<Prissoknad> | undefined;
}

export function PrissoknadCardOversikt({
                                           resoknadMedlemskap,
                                           prissøknader
                                       }: Props) {
    const innsendtPrissøknad = useMemo(() => {
        return prissøknader?.find(prissøknad => {
            return prissøknad.søknadstype === 'FØRSTEGANG' && (
                erAktiv(prissøknad)
            )
        })
    }, [prissøknader])

    const harAktivResoknad = useMemo(() => {
        return prissøknader?.some(prissøknad => {
            return prissøknad.søknadstype === 'RESØKNAD' && (
                erAktiv(prissøknad)
            )
        })
    }, [prissøknader])

    const getPrissøknadStatus = () => {
        if (innsendtPrissøknad) {
            return <InnsendtPrissøknad mottattDato={innsendtPrissøknad.innsendtdato}/>
        } else if (harAktivResoknad) {
            return <AktivResøknadCard/>
        } else {
            return <ResøknadslistenMenIngenSøknad/>
        }
    }

    return (
        resoknadMedlemskap !== ResoknadMedlemskap.AKTIV ? "" :
            <div className={"my-size-24"}>
                {getPrissøknadStatus()}
            </div>
    )

}
